import { SVGProps } from 'react';

const SvgUnitedKingdom = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#united-kingdom_svg__a)">
      <path fill="#F0F0F0" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12" />
      <path
        fill="#0052B4"
        d="M2.48 4.695A12 12 0 0 0 .414 8.871h6.243zM23.587 8.87a12 12 0 0 0-2.068-4.175l-4.175 4.176zM.413 15.133a12 12 0 0 0 2.068 4.175l4.175-4.175zM19.306 2.481A12 12 0 0 0 15.13.414v6.243zM4.694 21.52a12 12 0 0 0 4.176 2.066v-6.242zM8.87.414a12 12 0 0 0-4.176 2.067L8.87 6.657zM15.13 23.586a12 12 0 0 0 4.176-2.067l-4.176-4.175zM17.344 15.133l4.175 4.175a12 12 0 0 0 2.068-4.175z"
      />
      <path
        fill="#D80027"
        d="M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
      />
      <path
        fill="#D80027"
        d="m15.13 15.129 5.355 5.355q.37-.37.706-.77l-4.585-4.585zM8.87 15.129l-5.355 5.355q.37.368.77.705l4.585-4.584zM8.87 8.87 3.515 3.516q-.37.37-.706.77l4.585 4.585zM15.13 8.869l5.355-5.355a12 12 0 0 0-.77-.705L15.13 7.393z"
      />
    </g>
    <defs>
      <clipPath id="united-kingdom_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUnitedKingdom;
